import React from "react";
import { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import NavButton from "../homepage/header-banner/TopNavButton";
import Footer from "../homepage/footer/Footer";
import "./assets/css/style-page2.css";
import "../Style/typo.css";
import "../Style/defaultstyle.css";
import BgBottom from "./assets/image/bg-bottom.png";
import FrameBG from "./assets/image/Frame.png";
import Image763 from "./assets/image/image 763.png";
import AiImg1 from "./assets/image/ai-img1.png";
import AiImg2 from "./assets/image/ai-img2.png";
import AiFilled from "./assets/image/ai-filled.svg";
import GroupwareCRM from "./assets/image/groupware-crm 1.png";
import VectorBan from "./assets/image/vector-ban.png";
import VectorLine from "./assets/image/Vector 3.png";
import ReturnVisitor from "./assets/image/returning_visitor.png";
import { Check } from "@mui/icons-material";
import { ChevronRight } from "@mui/icons-material";
import { ArrowRightAlt } from "@mui/icons-material";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import EmailIcon from "@mui/icons-material/Email";
import ForumIcon from "@mui/icons-material/Forum";
import PhoneIcon from "@mui/icons-material/Phone";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DnsIcon from "@mui/icons-material/Dns";
import GroupsIcon from "@mui/icons-material/Groups";
import ApartmentIcon from "@mui/icons-material/Apartment";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import FadeInSection from "../container/component/Fadeanimation/FadeInSection";
import langData from "../translations/translations.json";

const ScrollToSection = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const section = document.querySelector(location.hash);
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);

    return null;
};

function IndexPage2() {
    const currentLang = "ko";
    const content = langData.headerBan;
    const [activated, setActivated] = useState(false);
    const sectionRef = useRef(null);
    const [showImgBox, setShowImgBox] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    const storageName = "rememberMe";

    useEffect(() => {
        document.title = "한비로 - Home";
    }, []);

    useEffect(() => {
        const savedDate = localStorage.getItem(storageName);

        if (savedDate) {
            const saved = new Date(savedDate);
            const today = new Date();

            if (saved.toDateString() !== today.toDateString()) {
                setShowImgBox(true);
            } else {
                setShowImgBox(false);
            }
        } else {
            setShowImgBox(true);
        }
    }, []);
    const handleConfirm = () => {
        const date = new Date();
        localStorage.setItem(storageName, date.toString());
        setShowImgBox(false);
        setImageLoaded(false);
    };

    const handleClose = () => {
        setShowImgBox(false);
        setImageLoaded(false);
    };
    const handleReset = () => {
        localStorage.removeItem(storageName);
        setShowImgBox(true);
        setImageLoaded(false);
    };

    const handleImageLoad = () => {
        setImageLoaded(true);
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setActivated(false);
                    setTimeout(() => setActivated(true), 200);
                }
            },
            { threshold: 0.5 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    const CountUp = ({ start, end, duration, activated }) => {
        const [count, setCount] = useState(start);

        useEffect(() => {
            if (activated) {
                setCount(start);
                let current = start;
                const step = (end - start) / (duration * 60);

                const interval = setInterval(() => {
                    current += step;
                    if (current >= end) {
                        setCount(end);
                        clearInterval(interval);
                    } else {
                        setCount(Math.ceil(current));
                    }
                }, 1000 / 60);

                return () => clearInterval(interval);
            }
        }, [activated, start, end, duration]);

        return <span>{count.toLocaleString()}</span>;
    };

    useEffect(() => {
        const featureBoxes = document.querySelectorAll(".feature-box-col");

        featureBoxes.forEach((featureBox) => {
            const slideContainer = featureBox.querySelector(".slides");
            const dotsContainer = featureBox.querySelector(".dots");
            if (!slideContainer || !dotsContainer) return;

            const totalSlides = slideContainer.querySelectorAll("img").length;
            let currentIndex = 0;

            dotsContainer.innerHTML = "";

            for (let i = 0; i < totalSlides; i++) {
                const dot = document.createElement("div");
                dot.classList.add("dot");
                if (i === 0) dot.classList.add("active");
                dotsContainer.appendChild(dot);

                dot.addEventListener("click", () => {
                    currentIndex = i;
                    updateSlidePosition();
                    updateDots();
                });
            }

            const dots = dotsContainer.querySelectorAll(".dot");

            const updateSlidePosition = () => {
                const slideWidth = slideContainer.clientWidth;
                slideContainer.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
            };

            const updateDots = () => {
                dots.forEach((dot, index) => {
                    dot.classList.toggle("active", index === currentIndex);
                });
            };

            const autoSlide = () => {
                currentIndex = (currentIndex + 1) % totalSlides;
                updateSlidePosition();
                updateDots();
            };

            const interval = setInterval(autoSlide, 3000);

            const tabButtons = document.querySelectorAll('[data-bs-toggle="pill"]');
            tabButtons.forEach((tab) => {
                tab.addEventListener("click", () => {
                    currentIndex = 0;
                    updateSlidePosition();
                    updateDots();
                });
            });

            return () => clearInterval(interval);
        });
    }, []);

    return (
        <div className="indexpage2">
            <NavButton
                lang="ko"
                option={{
                    logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                    link: "https://hanbiro.com/",
                    color: { backgroundColor: "#7061FF" },
                    itemNavClass: "item-nav nav-pur",
                    menuListProduct: "menu-list-product-item",
                    menuListVora: "vora",
                    menuListGroupware: "groupware",
                    titleTab: "mb-3",
                }}
            />
            <ScrollToSection />
            <div className="header-ban">
                <div className="fit-box p-r-l">
                    <FadeInSection>
                        <div className="header-ban-tt">
                            <div className="header-ban-tt-left">
                                <p className="txt-48 wh-color mb-2">기업 IT 환경구축 • 운영</p>
                                <p className="txt-21 wh-color">
                                    인프라 구축부터 소프트웨어 , 하드웨어, AI협업까지 한번에 해결하는 <br />
                                    맞춤형 클라우드 기반의 최적화 IT 솔루션을 제공합니다.
                                </p>
                                <div className="feature-btn-gr header-btn-group theme-purple">
                                    <a className="typo-14 url-btn" href="https://hanbiro.com/#/groupware-free-trial">
                                        <button className="btn--default btn--secondary">그룹웨어 무료체험</button>
                                    </a>
                                    <a className="url-btn typo-14" href="https://hanbiro.com/#/server-signup-ko">
                                        <button className="btn--default btn--secondary">Cloud 서비스신청</button>
                                    </a>
                                </div>
                            </div>
                            <div className="header-ban-tt-right">
                                <Link to="#ai-feature2" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="vector-icon wh-color" />
                                    </div>
                                    <div className="ban-tt-text wh-color">{content["aiSolution"][currentLang]}</div>
                                </Link>
                                <Link to="#ai-feature4" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="vector-icon wh-color" />
                                    </div>
                                    <div className="ban-tt-text wh-color">{content["cloudService"][currentLang]}</div>
                                </Link>
                                <Link to="#ai-feature4" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="vector-icon wh-color" />
                                    </div>
                                    <div className="ban-tt-text wh-color">{content["kubernetes"][currentLang]}</div>
                                </Link>
                                <Link to="#ai-feature4" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="vector-icon wh-color" />
                                    </div>
                                    <div className="ban-tt-text wh-color">{content["aiGroupware"][currentLang]}</div>
                                </Link>
                                <Link to="#ai-feature4" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="vector-icon wh-color" />
                                    </div>
                                    <div className="ban-tt-text wh-color">{content["microserviceApi"][currentLang]}</div>
                                </Link>
                            </div>
                        </div>
                    </FadeInSection>
                </div>
            </div>

            <div className="wrap-box ai-LLM" id="ai-LLM">
                <div className="fit-box">
                    <FadeInSection>
                        <div className="wrap-title">
                            <p className="typo-32-mb">AI 그룹웨어·협업솔루션</p>
                            <p className="typo-21">기업전용 AI • LLM 서버운영 / 고객의 데이터 학습제외 • 고객데이터보호</p>
                        </div>

                        <div className="feature-dt">
                            <div className="fea-dt">
                                <div className="fea-dt-box">
                                    <div className="fea-dt-col left">
                                        <div className="fea-dt-row">
                                            <div className="fea-dt-item">
                                                <div className="fea-item">
                                                    <p className="typo-21-sm typo-medium">메일</p>
                                                    <p className="typo-14">요약 번역·초안작성</p>
                                                </div>
                                                <EmailIcon className="fea-icon" />
                                            </div>
                                            <div className="fea-dt-item">
                                                <div className="fea-item">
                                                    <p className="typo-21-sm typo-medium">메신저</p>
                                                    <div>
                                                        <p className="typo-14">자동번역·메시지전송 대화요약·번역</p>
                                                        {/* <p className="typo-14">대화요약·번역</p> */}
                                                    </div>
                                                </div>
                                                <ForumIcon className="fea-icon" />
                                            </div>
                                            <div className="fea-dt-item">
                                                <div className="fea-item">
                                                    <p className="typo-21-sm typo-medium">업무일지</p>
                                                    <p className="typo-14">요약·번역</p>
                                                </div>
                                                <FactCheckIcon className="fea-icon" />
                                            </div>
                                        </div>
                                        <div className="fea-dt-row">
                                            <div className="fea-dt-item">
                                                <div className="fea-item">
                                                    <p className="typo-21-sm typo-medium">전자결재</p>
                                                    <p className="typo-14">요약·번역·초안작성</p>
                                                </div>
                                                <RequestPageIcon className="fea-icon" />
                                            </div>
                                            <div className="fea-dt-item">
                                                <div className="fea-item">
                                                    <p className="typo-21-sm typo-medium">헬프데스크</p>
                                                    <p className="typo-14">요약·번역</p>
                                                </div>
                                                {/* <ConfirmationNumberIcon className="fea-icon" /> */}
                                                <div className="feature-highlight-btn">
                                                    <a className="url-btn typo-14 btn-center" href="https://hanbiro.com/#/helpdesk">
                                                        <button className="fea-button primary-btn">자세히 보기</button>
                                                    </a>
                                                </div>
                                            </div>
                                            {/* <div className="fea-dt-item aicall">
                                                <div className="fea-dt-item">
                                                    
                                                    <div className="fea-item">
                                                        <p className="typo-21-sm typo-medium">AI 전화</p>
                                                        <p className="typo-14">음성추출·요약·번역</p>
                                                    </div>

                                                </div>

                                                <div className="feature-highlight-btn">
                                                    <a className="url-btn typo-14 btn-center" href="https://hanbiro.com/software/ai-call-plus.html">
                                                        <button className="fea-button primary-btn">자세히 보기</button>
                                                    </a>
                                                </div>
                                            </div> */}
                                            <div className="fea-dt-item">
                                                <div className="fea-item">
                                                    <p className="typo-21-sm typo-medium">AI 전화</p>
                                                    <p className="typo-14">음성추출·요약·번역</p>
                                                </div>

                                                {/* <PhoneIcon className="fea-icon" /> */}
                                                <div className="feature-highlight-btn">
                                                    <a className="url-btn typo-14 btn-center" href="https://hanbiro.com/#/ai-call">
                                                        <button className="fea-button primary-btn">자세히 보기</button>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* <div className="feature-highlight">
                                <div className="feature-highlight-box">
                                    <div className="feature-highlight-ct">
                                        <span className="typo-21 highlight-span typo-medium m0">AI 전화</span>
                                        <span className="typo-21 m0">
                                            통화 내용을 <b>텍스트로 변환</b>하고, 핵심만 <b>간단히 요약하는 AI 솔루션</b>입니다.
                                        </span>
                                    </div>
                                    <div className="feature-highlight-btn">
                                        <a className="url-btn typo-14 btn-center" href="https://hanbiro.com/software/ai-call-plus.html">
                                            <button className="fea-button primary-btn">자세히 보기</button>
                                        </a>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </FadeInSection>
                </div>
            </div>

            <div className="wrap-box ai-feature2" id="ai-feature2">
                <div className="fit-box">
                    <FadeInSection>
                        <div className="wrap-title">
                            <p className="typo-32">그룹웨어</p>
                        </div>

                        <div className="ai-feature2-ct">
                            <ul className="nav nav-pills" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link typo-21 typo-medium active"
                                        id="pills-fea1-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-fea1"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-fea1"
                                        aria-selected="true"
                                    >
                                        메일
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link typo-21 typo-medium"
                                        id="pills-fea2-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-fea2"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-fea2"
                                        aria-selected="false"
                                    >
                                        메신저
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link typo-21 typo-medium"
                                        id="pills-fea3-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-fea3"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-fea3"
                                        aria-selected="false"
                                    >
                                        헬프데스크
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link typo-21 typo-medium"
                                        id="pills-fea4-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-fea4"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-fea4"
                                        aria-selected="false"
                                    >
                                        전자결재
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link typo-21 typo-medium"
                                        id="pills-fea5-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-fea5"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-fea5"
                                        aria-selected="false"
                                    >
                                        HR
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link typo-21 typo-medium"
                                        id="pills-fea6-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-fea6"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-fea6"
                                        aria-selected="false"
                                    >
                                        프로젝트
                                    </button>
                                </li>
                            </ul>
                            <div className="gw-menu-block gw-menu-block-tab">
                                <div className="menu-line">
                                    <p className="gw-menu-item typo-14">일정</p>
                                    <p className="gw-menu-item typo-14">주소록</p>
                                    <p className="gw-menu-item typo-14">게시판</p>
                                    <p className="gw-menu-item typo-14">쪽지</p>
                                    <p className="gw-menu-item typo-14">Clouddisk</p>
                                    <p className="gw-menu-item typo-14">회람판</p>
                                    <p className="gw-menu-item typo-14">Todo</p>
                                    <p className="gw-menu-item typo-14">문서관리</p>
                                    <p className="gw-menu-item typo-14">자산관리</p>
                                    <p className="gw-menu-item typo-14">비용보고</p>
                                    {/* <p className="gw-menu-item typo-14">다국어지원</p> */}
                                </div>
                            </div>
                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane show active" id="pills-fea1" role="tabpanel" aria-labelledby="pills-fea1-tab">
                                    <div className="feature-box">
                                        <div className="feature-box-col">
                                            <p className="typo-21 typo-medium">이메일 & 스팸 필터링</p>
                                            <div className="sub-tt">
                                                <p className="typo-14 txt-color">AI 기반 번역, 요약 기능을 제공합니다.</p>
                                                <p className="typo-14 txt-color">별도 구매 없이, 그룹웨어 내 스팸 솔루션이 기본으로 포함되어 있습니다.</p>
                                            </div>

                                            <div className="feature-box-text">
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">SPF, DKIM, DMARC</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">POP3/IMAP, 스팸 95% 차단</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">보안메일 , 승인 메일 , 대량 메일</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">외부메일 연동 , 메일함 공유 ( 퇴사자 포함 )</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">퇴사자 메일 공유, 퇴사자 메일 전달</p>
                                                </div>
                                            </div>

                                            <div className="feature-btn-gr">
                                                <a className="url-btn typo-14" href="https://hanbiro.com/#/mail-free-trial">
                                                    <button className="btn--default btn--primary">데모 신청</button>
                                                </a>
                                                <a className="url-btn typo-14" href="https://hanbiro.com/#/pricing">
                                                    <button className="btn--default btn--secondary">요금안내</button>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="feature-box-col">
                                            <div className="feature-box-img feature-shadow">
                                                <div className="slides">
                                                    {/* <img src="https://hanbiro.com/assets/images/cloud/mail-summary-1-sm.png" alt="Slide 1" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/mail-spam-1-sm.png" alt="Slide 2" /> */}
                                                    <img src="https://hanbiro.com/assets/images/cloud/mail-summary-1-sm.png" alt="Slide 1" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/ai-call-1-sm.png" alt="Slide 2" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/mail-spam-1-sm.png" alt="Slide 3" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/project-1-sm.png" alt="Slide 4" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/task-summary-1-sm.png" alt="Slide 5" />
                                                </div>
                                            </div>
                                            <div className="dots"></div>
                                        </div>
                                        {/* <div className="feature-box-col">
                                        <div className="feature-box-img">
                                            <img src="https://hanbiro.com/assets/images/cloud/1.gif" />
                                        </div>
                                    </div> */}
                                    </div>
                                </div>
                                <div className="tab-pane" id="pills-fea2" role="tabpanel" aria-labelledby="pills-fea2-tab">
                                    <div className="feature-box">
                                        <div className="feature-box-col">
                                            <p className="typo-21 typo-medium mb-2">메신저 & 회상회의</p>
                                            <div className="sub-tt">
                                                <p className="typo-14 txt-color">팀원들과 자유롭게 실시간 소통합니다.</p>
                                            </div>

                                            <div className="feature-box-text">
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">화상회의 내용요약및 번역</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">실시간 대화번역 • 오늘의 대화요약</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">화면 공유 및 보이스톡, 화상회의 기능을 통한 업무 협업 지원</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">게스트와의 화상회의 지원</p>
                                                </div>
                                            </div>

                                            <div className="feature-btn-gr">
                                                <a className="url-btn typo-14" href="https://hanbiro.com/#/messenger-free-trial">
                                                    <button className="btn--default btn--primary">데모 신청</button>
                                                </a>
                                                <a className="url-btn typo-14" href="https://hanbiro.com/#/pricing">
                                                    <button className="btn--default btn--secondary">요금안내</button>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="feature-box-col">
                                            <div className="feature-box-img feature-shadow">
                                                <div className="slides">
                                                    {/* <img src="https://hanbiro.com/assets/images/cloud/talk2-summary-1-sm.png" alt="Slide 1" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/talk2-translation-1-sm.png" alt="Slide 2" /> */}
                                                    <img src="https://hanbiro.com/assets/images/cloud/mail-summary-1-sm.png" alt="Slide 1" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/ai-call-1-sm.png" alt="Slide 2" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/mail-spam-1-sm.png" alt="Slide 3" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/project-1-sm.png" alt="Slide 4" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/task-summary-1-sm.png" alt="Slide 5" />
                                                </div>
                                            </div>
                                            <div className="dots"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="pills-fea3" role="tabpanel" aria-labelledby="pills-fea3-tab">
                                    <div className="feature-box">
                                        <div className="feature-box-col">
                                            <div className="fea-sub-tt">
                                                <p className="typo-21 typo-medium mb-2">티켓</p>
                                                <div>
                                                    <p className="typo-14 txt-color">여러 경로를 통해 들어오는 고객문의를 하나의 창구에서 관리합니다.</p>
                                                    <p className="typo-14 txt-color">접수부터 최종 답변이 제공될 때 까지의 모든 과정을 지속적으로 추적하고 지원합니다.</p>
                                                </div>
                                            </div>

                                            <div>
                                                <p className="typo-21 typo-medium mb-2">AI 전화</p>
                                                <div>
                                                    <p className="typo-14 txt-color">고객과의 전화 이력을 저장하고 분석합니다.</p>
                                                    <p className="typo-14 txt-color">이전 통화 기록과 관련 정보를 바탕으로 더 나은 서비스를 제공할 수 있도록 도와줍니다.</p>
                                                    <p className="typo-14 txt-color">AI기반 통화내용 요약 및 번역합니다.</p>
                                                </div>
                                            </div>

                                            <div className="feature-btn-gr">
                                                <a className="url-btn typo-14" href="https://hanbiro.com/#/groupware-free-trial">
                                                    <button className="btn--default btn--primary">데모 신청</button>
                                                </a>
                                                <a className="url-btn typo-14" href="https://hanbiro.com/#/pricing">
                                                    <button className="btn--default btn--secondary">요금안내</button>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="feature-box-col">
                                            <div className="feature-box-img feature-shadow">
                                                <div className="slides">
                                                    {/* <img src="https://hanbiro.com/assets/images/cloud/ai-call-1-sm.png" alt="Slide 1" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/helpdesk-ticket-view-1-sm.png" alt="Slide 2" /> */}
                                                    <img src="https://hanbiro.com/assets/images/cloud/mail-summary-1-sm.png" alt="Slide 1" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/ai-call-1-sm.png" alt="Slide 2" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/mail-spam-1-sm.png" alt="Slide 3" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/project-1-sm.png" alt="Slide 4" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/task-summary-1-sm.png" alt="Slide 5" />
                                                </div>
                                            </div>
                                            <div className="dots"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="pills-fea4" role="tabpanel" aria-labelledby="pills-fea4-tab">
                                    <div className="feature-box">
                                        <div className="feature-box-col">
                                            <p className="typo-21 typo-medium mb-2">전자결재</p>
                                            <div className="sub-tt">
                                                <p className="typo-14 txt-color">PC와 모바일을 통해 어제 어디서나 의사결정을 진행함으로써 빠른 업무 처리가 이루어집니다.</p>
                                            </div>

                                            <div className="feature-box-text">
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">무료 기본 양식 제공 ( 약 300 건 )</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">엑셀에디터 양식을 통한 자동수식, 간단 수식계산</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">보안결재를 이용한 이중 보안</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">양식별 결재선 지정 , 본인만의 자주쓰는 결재선 저장</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">ERP • SAP • 기타기간계시스템연동</p>
                                                </div>
                                            </div>

                                            <div className="feature-btn-gr">
                                                <a className="url-btn typo-14" href="https://hanbiro.com/#/groupware-free-trial">
                                                    <button className="btn--default btn--primary">데모 신청</button>
                                                </a>
                                                <a className="url-btn typo-14" href="https://hanbiro.com/#/pricing">
                                                    <button className="btn--default btn--secondary">요금안내</button>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="feature-box-col">
                                            <div className="feature-box-img feature-shadow">
                                                <div className="slides">
                                                    {/* <img src="https://hanbiro.com/assets/images/cloud/approval-view-1-sm.png" alt="Slide 1" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/approval-write-excel-1-sm.png" alt="Slide 2" /> */}
                                                    <img src="https://hanbiro.com/assets/images/cloud/mail-summary-1-sm.png" alt="Slide 1" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/ai-call-1-sm.png" alt="Slide 2" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/mail-spam-1-sm.png" alt="Slide 3" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/project-1-sm.png" alt="Slide 4" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/task-summary-1-sm.png" alt="Slide 5" />
                                                </div>
                                            </div>
                                            <div className="dots"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="pills-fea5" role="tabpanel" aria-labelledby="pills-fea5-tab">
                                    <div className="feature-box">
                                        <div className="feature-box-col">
                                            <p className="typo-21 typo-medium mb-2">근태관리 & 휴가관리</p>
                                            <div className="sub-tt">
                                                <p className="typo-14 txt-color">
                                                    기본근무제, 탄력근무제, 선택근무제 등의 다양한 근무유형을 제공하며, 연차관리의 자동화 통해 직원의 출/퇴근, 휴무일을 관리합니다.
                                                </p>
                                            </div>

                                            <div className="feature-box-text">
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">모바일을 통한 GPS, WIFI, Beacon 방식을 통한 출,퇴근</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">근태 승인 기능 제공</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">일/주/월 별 리포트 엑셀 다운로드 기능 제공</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">대시보드에 직원 출,퇴근 및 연차 현황 제공</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">연차관리 자동화 및 연차촉진제 지원</p>
                                                </div>
                                            </div>

                                            <div className="feature-btn-gr">
                                                <a className="url-btn typo-14" href="https://hanbiro.com/#/hr-free-trial">
                                                    <button className="btn--default btn--primary">데모 신청</button>
                                                </a>
                                                <a className="url-btn typo-14" href="https://hanbiro.com/#/pricing">
                                                    <button className="btn--default btn--secondary">요금안내</button>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="feature-box-col">
                                            <div className="feature-box-img feature-shadow">
                                                <div className="slides">
                                                    {/* <img src="https://hanbiro.com/assets/images/cloud/hr-timesheet-1-sm.png" alt="Slide 1" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/hr-vacation-status-1-sm.png" alt="Slide 2" /> */}
                                                    <img src="https://hanbiro.com/assets/images/cloud/mail-summary-1-sm.png" alt="Slide 1" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/ai-call-1-sm.png" alt="Slide 2" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/mail-spam-1-sm.png" alt="Slide 3" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/project-1-sm.png" alt="Slide 4" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/task-summary-1-sm.png" alt="Slide 5" />
                                                </div>
                                            </div>
                                            <div className="dots"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="pills-fea6" role="tabpanel" aria-labelledby="pills-fea6-tab">
                                    <div className="feature-box">
                                        <div className="feature-box-col">
                                            <p className="typo-21 typo-medium mb-2">프로젝트</p>
                                            <div className="sub-tt">
                                                <p className="typo-14 txt-color">회사에 맞게 업무 템플릿을 만들고, 그 일감에 맞는 업무 담당자 와 진행상황을 등록하여 체계적으로 업무를 관리합니다.</p>
                                            </div>

                                            <div className="feature-box-text">
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">회사별 맞춤 업무 플로우 설정 </p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">투명한 업무 지시로 담당자의 책임을 명확히하고 업무의 병목현상을 방지</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="typo-14 txt-color">변경사항 알림을 통해 실시간으로 업무 진행</p>
                                                </div>
                                            </div>

                                            <div className="feature-btn-gr">
                                                <a className="url-btn typo-14" href="https://hanbiro.com/#/groupware-free-trial">
                                                    <button className="btn--default btn--primary">데모 신청</button>
                                                </a>
                                                <a className="url-btn typo-14" href="https://hanbiro.com/#/pricing">
                                                    <button className="btn--default btn--secondary">요금안내</button>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="feature-box-col">
                                            <div className="feature-box-img feature-shadow">
                                                <div className="slides">
                                                    {/* <img src="https://hanbiro.com/assets/images/cloud/project-1-sm.png" alt="Slide 1" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/project-drag-drop-1-sm.png" alt="Slide 2" /> */}
                                                    <img src="https://hanbiro.com/assets/images/cloud/mail-summary-1-sm.png" alt="Slide 1" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/ai-call-1-sm.png" alt="Slide 2" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/mail-spam-1-sm.png" alt="Slide 3" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/project-1-sm.png" alt="Slide 4" />
                                                    <img src="https://hanbiro.com/assets/images/cloud/task-summary-1-sm.png" alt="Slide 5" />
                                                </div>
                                            </div>
                                            <div className="dots"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="menu-block">
                                    <div className="menu-line">
                                        <p className="menu-item typo-14">
                                            <b>다국어지원</b>
                                        </p>
                                        <p className="menu-item typo-14">
                                            <b>ERP - SAP 연동</b>
                                        </p>
                                        {/* <div className="menu-item typo-14"><b>프라이빗 LLM 서버 - AI 통합</b></div> */}
                                        <p className="menu-item typo-14">
                                            <b>iOS</b>
                                        </p>
                                        <p className="menu-item typo-14">
                                            <b>AI 통합</b>
                                        </p>
                                        <p className="menu-item typo-14">
                                            <b>Android</b>
                                        </p>
                                        <p className="menu-item typo-14">
                                            <b>Linux</b>
                                        </p>
                                        <p className="menu-item typo-14">
                                            <b>Mobile - Tablet</b>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FadeInSection>
                </div>
            </div>

            <div className="wrap-box ai-feature4" id="ai-feature4">
                <div className="fit-box">
                    <div className="wrap-title">
                        <p className="typo-32">프라이빗 클라우드</p>
                        {/* <div className="txt-21-thin">기업
                            전용 AI · LLM
                            서버운영     고객의 데이터 학습제외 · 고객데이터보호</div> */}
                    </div>

                    <div className="ai-feature4-ct">
                        <div className="feature-box">
                            <div className="feature-box-col">
                                <p className="typo-21 typo-medium kuber-title" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                    프라이빗 Kubernetes 인프라구축 • 관리운영
                                </p>
                                <div className="feature-box-text">
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-16">고객사 전용 프라이빗 클러스터 인프라구축, 보안강화</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-16">서버자원의 효율적인 운영, 리소스의 자동 축소 • 확장</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-16">자동재해복구 • 오토스케일링기능, 서비스의 영속성보장</p>
                                    </div>
                                </div>
                            </div>
                            <div className="feature-box-col">
                                <p className="typo-21 typo-medium kuber-title" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                    CLOUD 서버 관리 • 운영 서비스
                                </p>
                                <div className="feature-box-text">
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-16">리눅스, 윈도우 관리운영서비스 제공</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-16">전문 서버엔지니어의 관리 • 24시간 운영지원</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-16">8,000 관계사, 5,000 대의 서버운영 노하우보유</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="feature-box">
                            <div className="feature-box-col">
                                <p className="typo-21 typo-medium kuber-title" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                    VM·가상화시스템 / 기업전용 LLM • AI 시스템구축
                                </p>
                                <div className="feature-box-text">
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-16">무중단 가상화서버 구축 • 관리운영</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-16">기업전용 맞춤형 LLM • AI 인프라 구축 및 운영</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-16">완벽한 보안을 갖춘 기업 전용 CLOUD • AI 인프라</p>
                                    </div>
                                </div>
                            </div>
                            <div className="feature-box-col">
                                <p className="typo-21 typo-medium kuber-title" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                    클라우드기반 마이크로서비스 API
                                </p>
                                <div className="feature-box-text">
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-16">이벤트 소싱 기반 분산 아키텍처 및 서버리스 시스템 구축</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-16">IAM, OAuth, Role 기반 권한 관리 안전한 Access Control 제공</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-16">Workflow, Rule 기반 자동화로 비즈니스 프로세스 최적화</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="feature-btn-gr fill-btn">
                        <a className="url-btn typo-14 btn-center" href="https://hanbiro.com/#/server-signup-ko">
                            <button className="btn--default btn--primary">서비스 신청</button>
                        </a>
                    </div>
                </div>
            </div>

            <div className="reference">
                <div className="fit-box">
                    {/* <div className="typo-32 server-title"><span>고객 지원</span></div> */}
                    <div className="row refer_support">
                        <div className="col-md-12 col-lg-6">
                            <div className="support-box">
                                <h3 className="typo-21-sm typo-medium">업무시간 고객 지원</h3>
                                <div>
                                    <div>
                                        <p className="typo-16">서비스 신청 / 상담 / 장애 처리 / 입금, 결제 문의</p>
                                        <p className="typo-32 purple-primary">1544-4755</p>
                                        <div className="support-list">
                                            <div className="typo-12 typo-gray">서비스 신청 및 견적 : 내선 1 • 그룹웨어 관련 : 내선 2 • 메일 관련 : 내선 3 • SSL 관련 : 내선 4</div>
                                            <div className="typo-12 typo-gray">서버 관련 기술 : 내선 5 • 결제 관련 : 내선 6 • 기타 문의 : 내선 9</div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="support-fax">
                                    <p className="typo-16">FAX:&nbsp; 02)6919-2050</p>
                                </div> */}
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-6">
                            <div className="support-box">
                                <h3 className="typo-21-sm typo-medium">업무시간 외(야간, 공휴일) 고객 지원</h3>
                                <div className="support-content">
                                    <div>
                                        <div>
                                            <p className="typo-16">야간, 주말 및 공휴일 당직 근무자 24시간 대기</p>
                                            <p className="typo-32 purple-primary">070-4804-9691</p>
                                        </div>
                                    </div>
                                    <div className="support-fax">
                                        <p className="typo-16">리눅스/윈도우/그룹웨어: 010-7566-0056</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="wrap-box clients" id="clients">
                <div className="fit-box">
                    <div className="bg-bottom">
                        <div className="bg-bottom-left">
                            <p className="typo-32-mb typo-white">더 스마트한 업무, 더 빠른 성장</p>
                            <p className="typo-14 typo-white">스마트 그룹웨어로 불필요한 업무 시간을 줄이고, 핵심 업무에 집중하세요. 지금 바로 상담받고, 생산성 향상의 해답을 찾아보세요.</p>
                        </div>
                        <div className="bg-bottom-right">
                            <div className="feature-btn-gr theme-purple">
                                <a className="url-btn typo-14" href="https://hanbiro.com/#/groupware-free-trial">
                                    <button className="btn--default btn--secondary">데모 신청</button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="fit-box">
                    <div className="stats-section" ref={sectionRef}>
                        <div className="stats-row">
                            <div className="stats-card">
                                <div className="stats-des">
                                    <div className="stats-content">
                                        <p className="stats-tt typo-21-sm typo-medium">YEARS</p>
                                        <p className="stats-dt typo-14">한비로 업력</p>
                                    </div>

                                    <div className="stats-icon">
                                        <CalendarMonthIcon className="stats-fea-icon" />
                                    </div>
                                </div>
                                <div className="stats-value">
                                    <p className="typo-32 purple-primary">
                                        <CountUp start={0} end={24} duration={2} activated={activated} />
                                        <span className="typo-14 typo-black"> 년</span>
                                    </p>
                                </div>
                            </div>

                            <div className="stats-card">
                                <div className="stats-des">
                                    <div className="stats-content">
                                        <p className="stats-tt typo-21-sm typo-medium">SERVERS</p>
                                        <p className="stats-dt typo-14">서버 관리 운영</p>
                                    </div>
                                    <div className="stats-icon">
                                        <DnsIcon className="stats-fea-icon" />
                                    </div>
                                </div>
                                <div className="stats-value">
                                    <p className="typo-32 purple-primary">
                                        <CountUp start={0} end={5000} duration={2} activated={activated} />
                                        <span className="typo-14 typo-black"> 대</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="stats-row">
                            <div className="stats-card">
                                <div className="stats-des">
                                    <div className="stats-content">
                                        <p className="stats-tt typo-21-sm typo-medium">USERS</p>
                                        <p className="stats-dt typo-14">메일/그룹웨어 사용</p>
                                    </div>
                                    <div className="stats-icon">
                                        <GroupsIcon className="stats-fea-icon" />
                                    </div>
                                </div>
                                <div className="stats-value">
                                    <p className="typo-32 purple-primary">
                                        <CountUp start={0} end={300000} duration={2} activated={activated} />
                                        <span className="typo-14 typo-black"> 유저</span>
                                    </p>
                                </div>
                            </div>

                            <div className="stats-card">
                                <div className="stats-des">
                                    <div className="stats-content">
                                        <p className="stats-tt typo-21-sm typo-medium">COMPANY</p>
                                        <p className="stats-dt typo-14">그룹웨어 • 서버관리운영</p>
                                    </div>
                                    <div className="stats-icon">
                                        <ApartmentIcon className="stats-fea-icon" />
                                    </div>
                                </div>
                                <div className="stats-value">
                                    <p className="typo-32 purple-primary">
                                        <CountUp start={0} end={8000} duration={2} activated={activated} />
                                        <span className="typo-14 typo-black"> 사</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="wrap-title">
                        <div className="txt-32">한비로와 함께하는 다양한 고객사</div>
                        <div className="txt-32">한비로와 함께 성공적인 길로 나아가는 기업들입니다.</div>
                    </div> */}
                </div>

                <div className="newscroll-row">
                    <div className="new-scroll">
                        <div className="new-m-scroll">
                            <img src="https://hanbiro.com/assets/images/cloud/clients/1.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/2.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/3.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/4.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/5.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/6.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/7.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/8.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/9.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/10.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/11.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/12.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/13.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/14.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/15.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/16.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/17.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/18.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/19.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/20.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/21.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/22.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/23.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/24.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/25.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/26.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/27.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/28.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/29.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/30.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/31.png" />
                        </div>
                    </div>
                </div>
            </div>

            {showImgBox && (
                <div className="banner_new_year" id="imgbox1">
                    <div
                        className="banner-content-newyear"
                        style={{
                            minHeight: "494px",
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <a href="#" target="_blank" style={{ width: "100%", height: "100%" }}>
                            {!imageLoaded && (
                                <div
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                        backgroundSize: "200% 100%",
                                        animation: "loading 1.5s infinite",
                                        borderRadius: "8px",
                                    }}
                                />
                            )}

                            <img
                                className="banner-image-newyear"
                                src="https://hanbiro.com/assets/images/cloud/1767166899706232 1.png"
                                alt="New Year Banner"
                                onLoad={handleImageLoad}
                                style={{
                                    opacity: imageLoaded ? 1 : 0,
                                    transition: "opacity 0.3s ease-in-out",
                                    width: "100%",
                                    height: "auto",
                                    display: "block",
                                }}
                            />
                        </a>
                    </div>
                    <div className="popup-control-newyear">
                        <button className="confirm-btn-newyear" id="confirm" onClick={handleConfirm}>
                            <span>오늘 하루 그만보기</span>
                        </button>
                        <button className="close-btn-newyear" id="close" onClick={handleClose}>
                            닫기
                        </button>
                    </div>
                </div>
            )}

            <Footer
                option={{
                    textColor: "text-color external-link text-pur-color",
                    textlinkColor: "text-color text-pur-color",
                }}
            />
        </div>
    );
}

export default IndexPage2;
